export default () => (
  <svg
    width="19"
    height="13"
    viewBox="0 0 19 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1667 0.5C13.7064 0.5 13.3333 0.873096 13.3333 1.33333V9.32149L11.4226 7.41075C11.0972 7.08531 10.5695 7.08531 10.2441 7.41075C9.91864 7.73618 9.91864 8.26382 10.2441 8.58926L13.5763 11.9215L13.5866 11.9316C13.6637 12.0064 13.7517 12.0634 13.8453 12.1025C13.9442 12.1438 14.0528 12.1667 14.1667 12.1667C14.3922 12.1667 14.5967 12.0771 14.7467 11.9316L14.757 11.9215L18.0893 8.58926C18.4147 8.26382 18.4147 7.73618 18.0893 7.41075C17.7638 7.08531 17.2362 7.08531 16.9107 7.41075L15 9.32149V1.33333C15 0.873096 14.6269 0.5 14.1667 0.5ZM3.33333 3.34518L1.42259 5.25592C1.09715 5.58136 0.569515 5.58136 0.244078 5.25592C-0.0813592 4.93049 -0.0813592 4.40285 0.244078 4.07741L3.57672 0.744768C3.57876 0.742722 3.58081 0.740687 3.58288 0.738663C3.73323 0.591044 3.93931 0.5 4.16667 0.5C4.27966 0.5 4.3874 0.522488 4.48565 0.563232C4.58394 0.603899 4.67602 0.664181 4.75592 0.744078L8.08926 4.07741C8.41469 4.40285 8.41469 4.93049 8.08926 5.25592C7.76382 5.58136 7.23618 5.58136 6.91074 5.25592L5 3.34518V11.3333C5 11.7936 4.6269 12.1667 4.16667 12.1667C3.70643 12.1667 3.33333 11.7936 3.33333 11.3333V3.34518Z"
      fill="currentColor"
    />
  </svg>
);
